<template>
  <div>
    <common-dialog
      ref="dialog"
      :data="data"
      unit="语言资料"
      width="920px"
      @closed="onClosed"
      :get-data-func="api.info"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <span class>基础信息</span>
          </el-col>
        </el-row>
        <el-row class="row-border">
          <el-form-item label="资料标题">
            <span>{{ data.Title }}</span>
          </el-form-item>
          <el-form-item label="资料类别">
            <span>{{ data.Category }}</span>
          </el-form-item>
          <el-form-item label="状态">
           <el-tag type="info" v-if="data.Status==0">草稿</el-tag>
            <el-tag type="warning" v-else-if="data.Status==1">待审批</el-tag>
            <el-tag type="danger" v-else-if="data.Status==2">退回</el-tag>
            <el-tag type="success" v-else-if="data.Status==3">已审批</el-tag>
          </el-form-item>
          <el-form-item label="附件">
            <upload-file-list is-detail :file-list="data.Attachments" class="upload-item"></upload-file-list>
          </el-form-item>
        </el-row>
     <span v-if="data.ReviewTime != null && data.ReviewTime != '' ">审批信息</span>
        <el-row class="row-border" v-if="data.ReviewTime != null && data.ReviewTime != '' ">
          <el-col :span="12">
            <el-form-item label="审核人">{{ data.ReviewUserName }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审批时间">{{ data.ReviewTime }}</el-form-item>
           
          </el-col>
          <el-col :span="12">
            <el-form-item label="审批状态">
              <span v-if="data.Status == 0">草稿</span>
              <span v-if="data.Status == 1">待审批</span>
              <span v-if="data.Status == 2">退回</span>
              <span v-if="data.Status == 3">已审批</span>
            </el-form-item>
          </el-col>
          <el-col :span="12"  v-if="(data.Status == 0 && data.ReviewRemark !=null)||data.Status==2">
             <el-form-item label="退回原因"  >{{ data.ReviewRemark }}</el-form-item>
          </el-col>
        </el-row>
        <div>其他信息</div>
        <el-row class="row-border">
          <el-col :span="12">
            <el-form-item label="创建人">{{ data.AddUserName }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间">{{ data.AddTime }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="修改人">{{ data.UpdateUserName }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="修改时间">{{ data.UpdateTime }}</el-form-item>
          </el-col>
        </el-row>
      </template>
      <template #footer>
        <template v-if="$permission.canReview()">
          <el-button type="success" @click.stop="pass" v-if="data.Status == 1">通 过</el-button>
          <el-button type="danger" @click.stop="back(1)" v-if="data.Status == 1">退 回</el-button>
          <el-button type="danger" @click.stop="back(2)" v-if="data.Status == 3">撤销审批</el-button>
        </template>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
    <return-dialog ref="returnDialog" @confirm="toReturn"></return-dialog>
  </div>
</template>

<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import uploadFileList from "@/components/common/files/uploadFileList";
import returnDialog from "@/components/consult/lang/returnDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    uploadFileList,
    returnDialog
  },
  data() {
    return {
      api: require("@/api/consult/lang").default,
      data: {
        Attachments: [],
        VoiceId: 0,
        Title: "",
        Category: "",
        Status: 0,
        AddUserId: 0,
        AddDpId: 0,
        UpdateUserId: 0,
        ReviewUserId: 0,
        AddTime: '',
        AddUserName: '',
        ReviewUserName:'',
        UpdateUserName: '',
        UpdateTime: "",
        backType:null,
        ReviewRemark:'',
        ReviewTime:""
      },
    };
  },
  methods: {
    pass() {
      this.$confirm("确认通过吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading(true);
          this.api.pass({ Id: this.data.VoiceId, Type: "同意", Remark: "", }).then(res => {
            this.loading(false);
            if (res.Code == 0) {
              this.$message.success("操作成功");
              this.close();
              this.$emit("close-saved")
            } else {
              this.$message.error(res.Msg);
            }
          })
        })
        .catch(() => { });
    },
    back(t) {
      this.backType = t;
      this.$refs.returnDialog.open(t);
    },
    toReturn(data) {
      this.loading(true);
      if (this.backType == 1) {
        this.api
          .back({
            Id: this.data.VoiceId,
            Type: "退回",
            Remark: data.Remark,
          })
          .then((res) => {
            this.loading(false);
            if (res.Code == 0) {
              this.$message.success(res.Msg);
              this.close(true);
              this.$emit("close-saved");
            } else {
              this.$message.error(res.Msg);
            }
          });
      } else {
        this.api
          .cancelReview({ Id: this.data.VoiceId, Remark: data.Remark })
          .then((res) => {
            this.loading(false);
            if (res.Code == 0) {
              this.$message.success(res.Msg);
              this.close(true);
              this.$emit("close-saved");
            } else {
              this.$message.error(res.Msg);
            }
          });

      }
    },
    onClosed() {
      this.data.Attachments = [];
    },
    handleRemove(file, fileList) {
      //(file, fileList);
    },
    handlePreview(file) {
      //(file);
    }
  },
};
</script>

<style lang="scss" scoped>
/deep/ .upload-demo {
  line-height: 0 !important;
}
/deep/ .el-upload-list__item:first-child {
  margin-top: 0;
}
</style>